<template>
    <div contenteditable="true" @input="updateHTML" refs="actualMessage" id="actualMessage"></div>
</template>

<script>
  export default {
    props:['value'],
    mounted: function () {
      this.$el.innerHTML = this.value;
    },
    methods: {
      updateHTML: function(e) {
        this.$emit('input', e.target.innerHTML);
      },
    }
  }
</script>

<style lang="scss" scoped>
div[contenteditable] { 
  border: 1px solid #ced4da; height: 300px; border-radius: 5px; padding: 10px;
  
  }


</style>